import { createContext, useContext } from "react";
import { useBiofeedback } from "../hooks/useBiofeedback";

const BiofeedbackContext = createContext(null);

export const BiofeedbackProvider = ({ children }) => {
  const biofeedback = useBiofeedback();
  return (
    <BiofeedbackContext.Provider value={biofeedback}>
      {children}
    </BiofeedbackContext.Provider>
  );
};

export const useBiofeedbackContext = () => {
  const ctx = useContext(BiofeedbackContext);
  if (!ctx) throw new Error("useBiofeedbackContext must be used within BiofeedbackProvider");
  return ctx;
};
